import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { sessionSetItemObj, sessionGetItemJSON } from '../../utils/sessionHelpers'
import { startLoading, doneLoading } from '../../utils/loading'
import { sessionGetItemObj } from '../../utils/sessionHelpers'
import ProjectInfoDocTable from './ProjectInfoDocTable'
import ProjectInfoDocInfo from './ProjectInfoDocInfo'
import { downloadSubprojectFile } from '../../redux/actions/subProject'
import notification from '../../utils/notification'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { callGetDownloadService } from '../attachfiles/AttachFilesViewDownload'

export default function ProjectInfoDocWidget(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  console.log('formSchema==>', formSchema)
  const history = useHistory()

  const projectCode = sessionStorage.getItem('projectCode')
  const projectId = sessionStorage.getItem('projectId')

  const handleDownload = async (fileObj) => {
    startLoading()
    try {
      if (!fileObj){
        notification.open('error', {
          title: 'ไม่พบ fileObj',
          duration: 5000,
        })

        return
      }

      var file 
      let _fileObj = {
        ...fileObj,
        path: fileObj.filePath || '',
        isCompleted: fileObj.isContract ?? false
      }

      if(_fileObj.isContract){
        let error = await callGetDownloadService(projectId, _fileObj, 'download')
        console.log(error)
        if (error){
          notification.open('error', {
            title: 'ไม่สำเร็จ',
            duration: 5000,
          })
        }
        doneLoading()
        return
      }else {
        file = await downloadSubprojectFile(fileObj.filePath)
      }

      var fileName = fileObj.documentName

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: e?.response?.statusText || 'ดาวน์โหลด ไม่สำเร็จ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handlePreview = async (fileObj) => {
    startLoading()
    try {
      if (!fileObj){
        notification.open('error', {
          title: 'ไม่พบ fileObj',
          duration: 5000,
        })

        return
      }

      var file 
      let _fileObj = {
        ...fileObj,
        path: fileObj.filePath || '',
        isCompleted: fileObj.isContract ?? false
      }

      if(_fileObj.isContract){
        let error = await callGetDownloadService(projectId, _fileObj, 'preview')
        console.log(error)
        if (error){
          notification.open('error', {
            title: 'ไม่สำเร็จ',
            duration: 5000,
          })
        }
        doneLoading()
        return
      }else {
        file = await downloadSubprojectFile(fileObj.filePath)
      }

      var fileName = fileObj.documentName

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: e?.response?.statusText || 'แสดง ไม่สำเร็จ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded bordered>
        {/* <ProjectInfoDocInfo schema={formSchema?.projectInfo} />
        <br /> */}
        <ProjectInfoDocTable
          schema={formSchema}
          loading={isLoading}
          onDownload={handleDownload}
          onPreview={handlePreview}
        />

        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}
